// LGEBR-572
// LGEMS-212 modify
$(document).ready(function() {
	if(!document.querySelector('.promotion-slide-wrap')) return false;
	var infinite=false;
	var dots=false;
	var autoplay=false;
	var promoslideChangeItem = 1;
	var promoslideTimeFlag = $("#promoslideTimeFlag").val();
	var promoslideDotFlag = $("#promoslideDotFlag").val();
	var promoslideInitTimeD = parseInt($("#promoslideInitTimeD").val());
	var promoslideChangeTimeD = parseInt($("#promoslideChangeTimeD").val());
	var promoslideInitTimeM = parseInt($("#promoslideInitTimeM").val());
	var promoslideChangeTimeM = parseInt($("#promoslideChangeTimeM").val());
	
	var autoplaySpeed=promoslideInitTimeD;
	var autoplaySpeedM=promoslideInitTimeM;
        //LGEBR-706
	var playIndicator = '<div class="promotion-slide-indicators"><div class="slick-dots-container"></div><button class="slick-play-pause paused" type="button">Play</button></div>';

        //LGEBR-706
	var playIndicator = '<div class="promotion-slide-indicators"><div class="slick-dots-container"></div><button class="slick-play-pause paused" type="button">Play</button></div>';
	if(promoslideTimeFlag=='Y'){
		infinite = true;
		autoplay = true;
		promoslideChangeItem = parseInt($("#promoslideChangeItem").val());
	}
	if(promoslideDotFlag=='Y'){
		dots=true;
	}
	var $obj = $('.promotion-slide-wrap');
	$(".promotion-inner-box").append(playIndicator); //LGEBR-706
	//LGEBR-947
	if($('html').data('countrycode') == 'br' || $('html').data('countrycode') == 'cac' || $('html').data('countrycode') == 'cac_en'){ //LGEPA-874
	$obj.find('.promotion-items').addClass('apply-rows');
	var $slick = $obj.find('.promotion-items').slick({
		infinite: infinite,
		slidesToShow: 4,
		rows: 2,
		slidesToScroll: promoslideChangeItem,
		arrows : true,
		dots: dots,
		draggable: false,
		swipe : false,
		appendDots: $('.promotion-slide-indicators .slick-dots-container'),
		autoplay :autoplay,
		autoplaySpeed : autoplaySpeed,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					draggable: true,
					swipe : true,
					autoplay :autoplay,
					autoplaySpeed:autoplaySpeed,
					rows: 1
				}
			},
			{
			  breakpoint: 768,
			  settings: {
				autoplay: autoplay,
				autoplaySpeed: autoplaySpeedM,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				dots: true,
				draggable: true,
				swipe : true,
				rows: 1
			 }
			}
		],
		prevArrow: carouselOptions.squarePrev,
		nextArrow: carouselOptions.squareNext
	});
    } else {
    	var $slick = $obj.find('.promotion-items').slick({
    		infinite: infinite,
    		slidesToShow: 4,
    		slidesToScroll: promoslideChangeItem,
    		arrows : true,
    		dots: dots,
    		draggable: false,
    		swipe : false,
    		appendDots: $('.promotion-slide-indicators .slick-dots-container'),
    		autoplay :autoplay,
    		autoplaySpeed : autoplaySpeed,
    		responsive: [
    			{
    				breakpoint: 1200,
    				settings: {
    					slidesToShow: 2,
    					slidesToScroll: 1,
    					draggable: true,
    					swipe : true,
    					autoplay :autoplay,
    					autoplaySpeed:autoplaySpeed
    				}
    			},
    			{
    			  breakpoint: 768,
    			  settings: {
    				autoplay: autoplay,
    				autoplaySpeed: autoplaySpeedM,
    				slidesToShow: 1,
    				slidesToScroll: 1,
    				arrows: true,
    				dots: true,
    				draggable: true,
    				swipe : true
    			 }
    			}
    		],
    		prevArrow: carouselOptions.squarePrev,
    		nextArrow: carouselOptions.squareNext
    	});
    }
	

	if(promoslideTimeFlag=='Y'){
		$obj.find('.promotion-items').on('afterChange', function(event, slick, currentSlide, nextSlide){
				if ( $(window).width() > 768 ) {
					$obj.find('.promotion-items').slick('slickSetOption', 'autoplaySpeed', promoslideChangeTimeD);
				}else{
					$obj.find('.promotion-items').slick('slickSetOption', 'autoplaySpeed', promoslideChangeTimeM);
				}
		});
	}

	//LGEBR-706 s
	$obj.find('.slick-play-pause').click( function() {
		if ($(this).hasClass('playing')){
			$(this)
				.removeClass('playing')
				.addClass('paused')
				.html('Pause');
			$slick.slick('slickPlay');
		} else {
			$(this)
				.removeClass('paused')
				.addClass('playing')
				.html('Play');
			$slick.slick('slickPause');
		}  
	});
	//LGEBR-706

	//LGECO-217 s
	$(window).on('resize load',function(){
		setTimeout(function() {
			if($('.promotion-slide-indicators .slick-dots-container li').length<=1){
				$('.promotion-slide-indicators .slick-play-pause').hide()
			}else{
				$('.promotion-slide-indicators .slick-play-pause').show()
			}
		}, 200);
	});
	//LGECO-217 e
});